import { ContentIdPicker } from '../_components/content-id-picker';
import { parseContentIds } from '../_components/content-id-utils.mjs';
import { StructuredListPreview } from '../_components/structured-list-preview';
import metadata from '../../../blocks/child-pages/block.json';

const { InspectorControls, useBlockProps } = wp.blockEditor;
const { PanelBody, SelectControl, TextControl, ToggleControl } = wp.components;
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { applyFilters } = wp.hooks;

export default registerBlockType(metadata.name, {
	apiVersion: metadata.apiVersion,
	title: metadata.title,
	icon: metadata.icon,
	keywords: [
		__('Sitemap', 'simple-sitemap'),
		__('Child pages', 'simple-sitemap'),
		__('Page hierarchy', 'simple-sitemap'),
	],
	category: metadata.category,
	example: metadata.example,
	supports: metadata.supports,
	edit: function Edit({ attributes, context, setAttributes }) {
		const blockProps = useBlockProps({
			className: 'simple-sitemap-editor-preview-wrapper',
		});
		const {
			parent_id,
			depth,
			orderby,
			order,
			show_parent,
			post_type = 'page',
		} = attributes;
		const proControls = applyFilters(
			'simple-sitemap-child-pages-pro-controls',
			'',
			{ attributes, setAttributes }
		);

		return [
			<InspectorControls key="simple-sitemap-child-pages-controls">
				<PanelBody title={__('Child Page Settings', 'simple-sitemap')}>
					<ContentIdPicker
						label={__('Parent page', 'simple-sitemap')}
						help={__(
							'Enter one page ID. Leave empty to use the page containing this block.',
							'simple-sitemap'
						)}
						value={parent_id > 0 ? String(parent_id) : ''}
						postTypes={[post_type]}
						multiple={false}
						manualLabel={__(
							'Manual parent page ID',
							'simple-sitemap'
						)}
						onChange={(value) => {
							const [selectedParent = 0] = parseContentIds(value);
							setAttributes({ parent_id: selectedParent });
						}}
					/>
					<TextControl
						type="number"
						label={__('Maximum depth', 'simple-sitemap')}
						help={__(
							'Use 0 to display every descendant level.',
							'simple-sitemap'
						)}
						min="0"
						max="10"
						value={depth}
						onChange={(value) => {
							const parsedDepth = Number.parseInt(value, 10);
							setAttributes({
								depth: Number.isNaN(parsedDepth)
									? 0
									: Math.min(10, Math.max(0, parsedDepth)),
							});
						}}
					/>
					<SelectControl
						label={__('Order by', 'simple-sitemap')}
						value={orderby}
						options={[
							{
								label: __(
									'Page order, then title',
									'simple-sitemap'
								),
								value: 'menu_order',
							},
							{
								label: __('Title', 'simple-sitemap'),
								value: 'title',
							},
							{
								label: __('Date', 'simple-sitemap'),
								value: 'date',
							},
							{ label: __('ID', 'simple-sitemap'), value: 'ID' },
						]}
						onChange={(value) => setAttributes({ orderby: value })}
					/>
					<SelectControl
						label={__('Order', 'simple-sitemap')}
						value={order}
						options={[
							{
								label: __('Ascending', 'simple-sitemap'),
								value: 'asc',
							},
							{
								label: __('Descending', 'simple-sitemap'),
								value: 'desc',
							},
						]}
						onChange={(value) => setAttributes({ order: value })}
					/>
					<ToggleControl
						label={__('Show parent page', 'simple-sitemap')}
						help={__(
							'Display the selected parent as the linked root of the hierarchy.',
							'simple-sitemap'
						)}
						checked={show_parent}
						onChange={(value) =>
							setAttributes({ show_parent: value })
						}
					/>
				</PanelBody>
				{proControls}
			</InspectorControls>,
			<div key="simple-sitemap-child-pages-preview" {...blockProps}>
				<StructuredListPreview
					path="/simple-sitemap/v1/child-pages-preview"
					attributes={attributes}
					requestData={{ context_post_id: context.postId || 0 }}
					maxDepth={depth}
				/>
			</div>,
		];
	},
	save() {
		return null;
	},
});
